import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { showAlertError } from 'src/components/alertError'
import { showAlertSuccess } from 'src/components/alertSuccess'
import KeyboardPressPasswordEletronic from 'src/components/keyPressPasswordeletronic'
import { OTPInput } from 'src/components/OTPInput'
import { getBalance } from 'src/requests/transfeera/get-balance'
import { service } from 'src/services/ajio'
import { isAxiosError } from 'src/utils/isAxiosError'
import { setAuthToken } from 'src/utils/setAuthToken'
import { useAuth } from '../../hooks/auth'
import { Billet } from '../payBillsPayInvoice'

export const PayBillsInfoInvoice: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const { account, refresh, user } = useAuth()
  const [clickedValues, setClickedValues] = useState<string[]>([])

  const state = location.state as Billet

  const handleKeyPress = (value: string) => {}

  const [isTypingPassword, setIsTypingPassword] = useState(false)

  const [balance, setBalance] = useState(0)

  const getBalanceAccount = async () => {
    const balance = await getBalance()
    if (balance?.value) {
      setBalance(balance?.value)
    } else {
      setBalance(0)
    }
  }

  useEffect(() => {
    getBalanceAccount()
  }, [])

  const handleConfirm = async (value: string[]) => {
    if (balance < state.barcode_details.value) {
      return showAlertError('Saldo insuficiente')
    }

    setLoading(true)

    try {
      setAuthToken()

      const result = await service.post('payments/', {
        ...state,
        accountId: account?.virtual_account_id,
      })

      showAlertSuccess('Boleto pago')
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        const errorMessage = (error.response.data as { error: string }).error
        showAlertError(errorMessage)
      } else {
        showAlertError('Ocorreu um erro inesperado.')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      {isTypingPassword ? (
        <div className="flex flex-col items-center">
          <p className="text-[1.875rem] font-semibold text-center">
            Insira a sua senha eletrônica de <br /> 8 dígitos para confirmar a
            ação:
          </p>
          <OTPInput length={8} formData={clickedValues} />
          <KeyboardPressPasswordEletronic
            onKeyPress={handleKeyPress}
            onConfirm={handleConfirm}
            updateParentInput={() => {}}
            updateClickedValues={(values: string[]) => setClickedValues(values)}
          />
        </div>
      ) : (
        <>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Detalhes do Boleto
          </h2>

          <div className="mb-6">
            <h3 className="text-xl font-semibold text-gray-700">
              Status: {state.status}
            </h3>
            <p className="text-gray-600">{state.message}</p>
          </div>

          <div className="mb-6">
            <h4 className="text-lg font-semibold text-gray-800 mb-2">
              Detalhes do Código de Barras
            </h4>
            <ul className="space-y-2 text-gray-600">
              <li>
                <strong>Banco:</strong> {state.barcode_details.bank_name} (
                {state.barcode_details.bank_code})
              </li>
              <li>
                <strong>Código de Barras:</strong>{' '}
                {state.barcode_details.barcode}
              </li>
              <li>
                <strong>Linha Digitável:</strong>{' '}
                {state.barcode_details.digitable_line}
              </li>
              <li>
                <strong>Vencimento:</strong> {state.barcode_details.due_date}
              </li>
              <li>
                <strong>Valor:</strong> R${' '}
                {state.barcode_details.value.toFixed(2)}
              </li>
              <li>
                <strong>Tipo:</strong> {state.barcode_details.type}
              </li>
            </ul>
          </div>

          <div className="mb-6">
            <h4 className="text-lg font-semibold text-gray-800 mb-2">
              Informações de Pagamento
            </h4>
            <ul className="space-y-2 text-gray-600">
              <li>
                <strong>Nome do Beneficiário:</strong>{' '}
                {state.payment_info.recipient_name}
              </li>
              <li>
                <strong>Documento do Beneficiário:</strong>{' '}
                {state.payment_info.recipient_document}
              </li>
              <li>
                <strong>Nome do Pagador:</strong>{' '}
                {state.payment_info.payer_name}
              </li>
              <li>
                <strong>Documento do Pagador:</strong>{' '}
                {state.payment_info.payer_document}
              </li>
              <li>
                <strong>Data de Vencimento:</strong>{' '}
                {state.payment_info.due_date}
              </li>
              <li>
                <strong>Data Limite:</strong> {state.payment_info.limit_date}
              </li>
              <li>
                <strong>Valor Original:</strong> R${' '}
                {state.payment_info.original_value.toFixed(2)}
              </li>
              <li>
                <strong>Valor Atualizado:</strong> R${' '}
                {state.payment_info.total_updated_value.toFixed(2)}
              </li>
              <li>
                <strong>Desconto:</strong> R${' '}
                {state.payment_info.total_discount_value.toFixed(2)}
              </li>
              <li>
                <strong>Multa:</strong> R${' '}
                {state.payment_info.fine_value.toFixed(2)}
              </li>
              <li>
                <strong>Juros:</strong> R${' '}
                {state.payment_info.interest_value.toFixed(2)}
              </li>
            </ul>
          </div>

          <div className="flex justify-center">
            <button
              onClick={() => setIsTypingPassword(true)}
              className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition duration-200"
            >
              Pagar Agora
            </button>
          </div>
        </>
      )}
    </div>
  )
}
